import * as yup from "yup";

export const otpCodeValidator = yup.object().shape({
  validationCode: yup
    .string()
    .matches(/^\d{4}$/, "کد تایید 4 رقم می باشد!")
    .required("این فیلد الزامی است!"),
});

export const phoneNumberValidator = yup.object().shape({
  input: yup
    .string()
    .required("این فیلد الزامی است!")
    .matches(/^09\d{9}$/, "شماره تلفن معتبر نمی‌باشد!"),
});

export const userRegisterFormValidator = yup.object().shape({
  userName: yup
    .string()
    .required("این فیلد الزامی است!")
    .matches(/^[^a-zA-Z]*$/, "کد‌ملی نمیتواند شامل حروف انگلیسی باشد!")
    .matches(/^[^\u0600-\u06FF]*$/, "نباید شامل حروف فارسی باشد!")
    .matches(/^\d{10}$/, "کد‌ملی 10 رقم می باشد!"),
  // licenseNumber: yup
  //   .string()
  //   .matches(/^\d{10}$/, "شماره گواهینامه 10 رقم می باشد!")
  //   .required("این فیلد الزامی است!"),
  // firstName: yup
  //   .string()
  //   .required("این فیلد الزامی است!")
  //   .matches(/^[^a-zA-Z]*$/, "نام راننده نمیتواند شامل حروف انگلیسی باشد!"),
  // lastName: yup
  //   .string()
  //   .required("این فیلد الزامی است!")
  //   .matches(
  //     /^[^a-zA-Z]*$/,
  //     "نام خانوادگی راننده نمیتواند شامل حروف انگلیسی باشد!"
  //   ),
  rules: yup
    .boolean()
    .oneOf([true], "لطفا پس از مطالعه قوانین و مقررات تاییدیه را انتخاب کنید.")
    .required(),
});

export const ownerRegisterFormValidator = yup.object().shape({
  userName: yup.string().required("این فیلد الزامی است!"),
  foreName: yup.string().required("این فیلد الزامی است!"),
  surName: yup.string().required("این فیلد الزامی است!"),
});

export const individualOwnerSignupFormValidator = yup.object().shape({
  userName: yup
    .string()
    .required("این فیلد الزامی است!")
    .matches(/^[^a-zA-Z]*$/, "کد‌ملی نمیتواند شامل حروف انگلیسی باشد!")
    .matches(/^[^\u0600-\u06FF]*$/, "نباید شامل حروف فارسی باشد!")
    .matches(/^\d{10}$/, "کد‌ملی 10 رقم می باشد!"),
  foreName: yup
    .string()
    .required("این فیلد الزامی است!")
    .matches(/^[^a-zA-Z]*$/, "نام صاحب‌بار نمیتواند شامل حروف انگلیسی باشد!"),
  surName: yup
    .string()
    .required("این فیلد الزامی است!")
    .matches(
      /^[^a-zA-Z]*$/,
      "نام خانوادگی صاحب‌بار نمیتواند شامل حروف انگلیسی باشد!"
    ),
  rules: yup
    .boolean()
    .oneOf([true], "لطفا پس از مطالعه قوانین و مقررات تاییدیه را انتخاب کنید.")
    .required(),
});

export const legalEntityOwnerSignupFormValidator = yup.object().shape({
  surName: yup.string().required("این فیلد الزامی است!"),
  CompanyNid: yup.string().required("این فیلد الزامی است!"),
  regCode: yup.string().required("این فیلد الزامی است!"),
  CompanyPostalCode: yup.string().required("این فیلد الزامی است!"),
  userName: yup.string().required("این فیلد الزامی است!"),
  foreName: yup.string().required("این فیلد الزامی است!"),
  rules: yup
    .boolean()
    .oneOf([true], "لطفا پس از مطالعه قوانین و مقررات تاییدیه را انتخاب کنید.")
    .required(),
});
